import { motion, useScroll, useSpring } from "framer-motion";
import { useLocation } from "react-router-dom";

const HIDDEN_ROUTES = ["/book", "/estimate", "/thank-you"];

const ScrollProgressBar = () => {
  const { pathname } = useLocation();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 24,
    restDelta: 0.001,
  });

  if (HIDDEN_ROUTES.includes(pathname)) return null;

  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] origin-left pointer-events-none"
      style={{
        scaleX,
        background:
          "linear-gradient(90deg, hsl(var(--gold-dark)) 0%, hsl(var(--gold)) 50%, hsl(var(--gold-light)) 100%)",
        boxShadow: "0 0 12px hsl(var(--gold) / 0.6), 0 0 24px hsl(var(--gold) / 0.3)",
      }}
    />
  );
};

export default ScrollProgressBar;
